import React from 'react';
import { useHistory } from 'react-router-dom';
import { useObserver } from 'mobx-react-lite';
import useLocalStorage from 'react-use-localstorage';

import { useStores } from 'src/hooks/use-stores';
import { Login } from 'src/components/user-flow/login';

export default function LoginRoute() {
  const history = useHistory();
  const { User } = useStores();
  const loggedIn = useObserver(() => User.loggedIn);
  const [redirectAfterLoginPath, setRedirectAfterLogin] = useLocalStorage('redirectAfterLogin', '');

  React.useEffect(() => {
    if (loggedIn) {
      history.replace('/redirect');
    }
  }, [history, loggedIn]);

  function handleOpenForgotPassword() {
    history.push('/forgot-password');
  }

  function onLoginSuccess() {
    const path = redirectAfterLoginPath?.length ? redirectAfterLoginPath : '/redirect';
    try {
      history.replace(path);
    } catch (e) {
      console.error(e);
      history.replace('/redirect');
    } finally {
      setRedirectAfterLogin('');
    }
  }

  return <Login onOpenForgotPassword={handleOpenForgotPassword} onSuccess={onLoginSuccess} />;
}
